import { styled } from "@mui/system";

export const HeaderContainer = styled("div")(() => ({
  width: "100%",
  height: 30,
  marginTop: 10,
}));
